import Swal from 'sweetalert2';

export const showError = (titleOrMessage, maybeText) => {
  let title = 'Error';
  let text = titleOrMessage;
  if (maybeText !== undefined) {
    title = titleOrMessage;
    text = maybeText;
  }
  Swal.fire({ icon: 'error', title, text });
};

export const showSuccess = (message) => {
  Swal.fire({ icon: 'success', title: 'Éxito', text: message });
};
export const showWarning = (titleOrMessage, maybeText) => {
  let title = 'Advertencia';
  let text = titleOrMessage;
  if (maybeText !== undefined) {
    title = titleOrMessage;
    text = maybeText;
  }
  Swal.fire({ icon: 'warning', title, text });
};
export function showLoading(title = 'Procesando...', text = 'Esto puede tardar unos segundos') {
  Swal.fire({
    title,
    text,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
}

export function closeLoading() {
  Swal.close();
}

// Confirmación antes de cerrar un mes: al cerrar se calcula la propuesta del F29 con lo cargado en
// ese momento, y lo que se cargue después no entra. Resuelve true si el usuario confirma.
export async function confirmarCierreMes(nombreMes, anio) {
  const r = await Swal.fire({
    title: `¿Cerrar ${nombreMes} ${anio}?`,
    html: `Al cerrar el mes se calcula la propuesta del F29 con lo que está cargado <b>ahora</b>.
      Lo que se cargue después no entra al F29 y, al subir el F29 pagado, no cuadrará.<br><br>
      Antes de cerrar, confirma que revisaste que estén completos:<br>
      <div style="text-align:left;display:inline-block;margin-top:8px">
        • Compras · Ventas · Boletas SII · Ventas POS<br>
        • Retención de honorarios<br>
        • Recursos humanos: liquidaciones de sueldo<br>
        • Arriendos · Patentes
      </div>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, cerrar el mes',
    cancelButtonText: 'Cancelar'
  });
  return r.isConfirmed;
}

// Confirmación antes de eliminar la carga de un período. Resuelve true si el usuario confirma.
export async function confirmarEliminacion(title, html) {
  const r = await Swal.fire({
    title,
    html,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33'
  });
  return r.isConfirmed;
}

// Confirmación antes de aprobar una cuenta propuesta: desde ese momento la usan todas las
// empresas. Resuelve true si el administrador confirma.
export async function confirmarAprobacionCuenta(nombreCuenta, codigo) {
  const r = await Swal.fire({
    title: `¿Aprobar ${nombreCuenta}?`,
    text: `Se creará ${nombreCuenta} con el código ${codigo} para todas las empresas.`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sí, aprobar',
    cancelButtonText: 'Cancelar'
  });
  return r.isConfirmed;
}

// Pide el motivo de rechazo de una cuenta propuesta (obligatorio). Resuelve el motivo, o
// null si el administrador cancela.
export async function pedirMotivoRechazo(nombreCuenta) {
  const r = await Swal.fire({
    title: `Rechazar ${nombreCuenta}`,
    input: 'textarea',
    inputLabel: 'Motivo del rechazo (lo verá quien propuso la cuenta)',
    showCancelButton: true,
    confirmButtonText: 'Rechazar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
    inputValidator: (valor) => (!valor || !valor.trim() ? 'El motivo es obligatorio' : undefined)
  });
  return r.isConfirmed ? r.value.trim() : null;
}

